
























import {Component, Vue, Prop} from 'vue-property-decorator'
import {InventoryItem} from '@/store/types'
import LeadRoomInventoryModel from '@/classes/LeadRoomInventoryModel'

@Component({})
export default class ListItem extends Vue {
  @Prop({type: Object, required: true}) public item!: InventoryItem
  @Prop({type: String, default: ''}) public iconClass!: string
  @Prop({type: String, default: 'border-bottom-light'}) public borderClass!: string

  public get packedBy() {
    if (this.item.packed_by === LeadRoomInventoryModel.PACKED_BY.MOVERS) {
      return 'CP'
    }
    if (this.item.packed_by === LeadRoomInventoryModel.PACKED_BY.CUSTOMER) {
      return 'PBO'
    }
  }
}
